// styles/media.js

export const breakpoints = {
  phone: 0,
  tablet: 640,
  laptop: 1024,
  desktop: 1280,
  wide: 1536,
};

export const media = {
  phone: `@media (max-width: ${breakpoints.tablet - 1}px)`,

  tablet: `@media (min-width: ${breakpoints.tablet}px)`,
  laptop: `@media (min-width: ${breakpoints.laptop}px)`,
  desktop: `@media (min-width: ${breakpoints.desktop}px)`,
  wide: `@media (min-width: ${breakpoints.wide}px)`,

  notPhone: `@media (min-width: ${breakpoints.tablet}px)`,
};
